import React from 'react'
import { Button, Typography, Paper, Dialog, DialogActions, DialogContent, DialogTitle, Input, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import swal from 'sweetalert';
import { import_products_catalogues_by_service } from '../../../../services/for_allServices';

const Store_existing_products = ({ open, handleClose, existingProducts, setopen_importProducts_to_catalogue_modal, get_supplier_by_id }) => {
    async function handleAllClose() {
        handleClose();
        setopen_importProducts_to_catalogue_modal(null);
    }
    let user = JSON.parse(localStorage.getItem('user-info'))
    const user_id = user.id;
    const user_role = user.role;

    async function submit_data() {
        const formData = new FormData();
        formData.append("performed_by", user_id);
        // formData.append("requester_role",user_role);
        formData.append("newExistingProducts", JSON.stringify(existingProducts));
        await import_products_catalogues_by_service(formData).then((response) => {
           //  console.log("Produits stockés avec succès:", response.data);
            swal("Les produits ont été mis à jour avec succès !", {
                icon: "success",
            });
            handleAllClose();
        }).catch((error) => {
           //  console.log("Erreur lors de l'ajout:", error.response);
        });

    }


    return (
        <Dialog open={open} fullWidth maxWidth="md">
            <DialogTitle>Produits existants</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    Certains produits existent déjà dans le stock. Voulez-vous les mettre à jour ?
                </Typography>
                <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Code produit</TableCell>
                                <TableCell>Nouveau Produit</TableCell>
                                <TableCell>Nouveau Fournisseur</TableCell>
                                <TableCell>Nouveau Prix</TableCell>
                                <TableCell>Ancien Produit</TableCell>
                                <TableCell>Ancien Fournisseur</TableCell>
                                <TableCell>Ancien Prix</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {existingProducts.map((product, index) => (
                                <TableRow key={index}>
                                    <TableCell>{product.code}</TableCell>
                                    <TableCell>{product.title}</TableCell>
                                    <TableCell>{get_supplier_by_id(product.supplier)}</TableCell>
                                    <TableCell>{product.price}</TableCell>
                                    <TableCell>{product.old_title}</TableCell>
                                    <TableCell>{get_supplier_by_id(product.old_supplier)}</TableCell>
                                    <TableCell>{product.old_price}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <div className='dialogBottom'>
                    <div>
                        <Button onClick={handleAllClose} variant="contained" className="submit_but cancel_but">Annuler</Button>
                        <Button onClick={submit_data} variant="contained" className="submit_but valide_but" >
                            Mettre à jour
                        </Button>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    );
};


export default Store_existing_products 
